import axios from "axios";
import { getToken } from "./tokenStore";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Default 60s — AI endpoints (evaluate / compare / tamper / quick-eval) routinely
// run ~15-30s on Gemini 2.5 Pro. Without an explicit timeout axios inherits the
// browser's ~120s default but some ingress proxies cut off at 30s.
const api = axios.create({ baseURL: API, timeout: 60000 });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

export const fileUrl = (id) => (id ? `${API}/files/${id}` : null);

/**
 * Best-effort human-friendly error extractor.
 * Prefers the backend's `detail` string, falls back to the HTTP status and
 * network-error hint — never returns a bare "Error".
 */
export function errMessage(err, lang = "ar") {
  const ar = lang === "ar";
  if (!err) return ar ? "حدث خطأ غير متوقع" : "Unexpected error";
  const detail = err.response?.data?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (detail && typeof detail === "object") {
    if (detail.message_ar && ar) return detail.message_ar;
    if (detail.message_en) return detail.message_en;
    if (detail.message) return detail.message;
  }
  if (err.code === "ECONNABORTED") {
    return ar
      ? "انتهت المهلة. التحليل قد يأخذ وقتاً أطول — حاول مرة أخرى."
      : "Timed out. The analysis may take longer — please retry.";
  }
  const status = err.response?.status;
  if (status === 413) return ar ? "الملف كبير جداً (الحد 10MB)" : "File too large (10MB max)";
  if (status === 415) return ar ? "الصيغة غير مدعومة — يقبل صور فقط" : "Only image files are supported";
  if (status === 429) return ar ? "محاولات كثيرة. انتظر دقيقة ثم أعد المحاولة." : "Too many attempts. Wait a minute then retry.";
  if (status === 502 || status === 503) {
    return ar
      ? "خدمة الذكاء الاصطناعي مشغولة حالياً. حاول بعد لحظات."
      : "AI service is busy. Please retry in a moment.";
  }
  if (status >= 500) return ar ? "خطأ من الخادم — حاول مرة أخرى." : "Server error — please try again.";
  if (!err.response) {
    return ar
      ? "تعذّر الاتصال. تحقق من الإنترنت وأعد المحاولة."
      : "Connection failed. Check your internet and retry.";
  }
  return err.message || (ar ? "حدث خطأ" : "An error occurred");
}
